import { render, staticRenderFns } from "./ComposeDialog.vue?vue&type=template&id=20ccf2d4&"
import script from "./ComposeDialog.vue?vue&type=script&lang=js&"
export * from "./ComposeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports